import { render, staticRenderFns } from "./ServiceVisitsList.vue?vue&type=template&id=092b3462&scoped=true&"
import script from "./ServiceVisitsList.vue?vue&type=script&lang=js&"
export * from "./ServiceVisitsList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceVisitsList.vue?vue&type=style&index=0&id=092b3462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092b3462",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VSkeletonLoader,VTooltip})
